
<div
	class="container"
	:data-type="type"
	:data-direction="direction"
	:data-overflow="overflow"
	:style="style"
	:data-gap="gap"
	:data-clickable="clickable"
	:data-background="background"
	:data-separator="separator"
	:data-old-safari="isOldSafari()"
	:class="['gap-' + gap]"
>
	<slot />
</div>
